import React from 'react'
import Switch from 'react-bootstrap-switch'
require('react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css')

export default class ActionsWidget extends React.Component {
  onChange(state) {
    this.props.toggleAuto(this.props.id, (result) => {})
  }

  render() {
    return (
      <div>
        <Switch ref={(child) => {this.switch = child}} onColor='success' defaultValue={this.props.status === 'auto'} onChange={this.onChange.bind(this)} />
      </div>
    )
  }
}
